import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Button from '../../../elements/Button';
import Text from '../../../elements/Text';
import { publish } from '../../../../_integrations/everymundo/tracking/pubsub';

const FareItemCheckRestriction = (props) => {
  const { callToAction, labelStyles, labelKey, eventName, ...rest } = props;

  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Button
      className={`call-to-action-button ${className}`}
      dataReactCmpOwner="fareItemCallToAction"
      style={style}
      onClick={(e) => {
        publish(eventName, rest);
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
      alignSelf="end"
      {...callToAction}
      dataTestId="fareItemCallToAction"
    >
      <Text {...labelStyles} dataReactCmpOwner="fareItemCallToAction">
        {translate(labelKey, 'Check restrictions')}
      </Text>
    </Button>
  );
};

FareItemCheckRestriction.propTypes = {
  /**
   * labelStyles props for using into withStyle.
   */
  labelStyles: PropTypes.objectOf(PropTypes.any),

  callToAction: PropTypes.objectOf(PropTypes.any),
  labelKey: PropTypes.string,
  eventName: PropTypes.string
};
FareItemCheckRestriction.defaultProps = {
  labelStyles: {},
  callToAction: {},
  labelKey: 'cmp-fare-item-check-restriction',
  eventName: 'em.travel.restriction.open'
};

FareItemCheckRestriction.componentName = 'FareItemCallToAction';

export default FareItemCheckRestriction;
